import React, { useState, useReducer, useContext } from 'react'
import { Link } from 'react-router-dom'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import styled from 'styled-components'
import ProfileForm from './ProfileForm'
import { JazeelContext } from '../../../utils/JazeelContext'
import { editProfile } from '../../../services/services'
import { useToasts } from 'react-toast-notifications'

const EditProfile = styled(Link)`
  color: #65d28e;
  font-size: 1.063em;
`
const ProfileSubContainer = styled.div``

const ProfileTitle = styled.h2``

export default function ProfilePage() {
  const { userData, setUserData } = useContext(JazeelContext)
  const { addToast } = useToasts()
  const [edit, setEdit] = useState(false)
  const [load, setLoad] = useState(false)

  const [profileInput, setProfileInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      lang: 'en',
      // auth_token: userData.auth_token,
      first_name: userData.first_name,
      last_name: userData.last_name,
      email: userData.email,
      gender: userData.gender,
      city: userData.city,
      phone: userData.phone,
      country: userData.country,
      // national_id: '',
      // bank_account_number: '',
      promo_code: userData.referral,
      password: '',
      conf: '',
    },
  )

  const stopLoader = () => {
    setLoad(false)
    setProfileInput({ password: '', conf: '' })
  }
  const handleSubmit = e => {
    e.preventDefault()
    setLoad(true)
    editProfile(
      userData,
      {
        lang: 'en',
        first_name: profileInput.first_name,
        last_name: profileInput.last_name,
        gender: profileInput.gender,
        city: profileInput.city,
        phone: profileInput.phone,
        country: profileInput.country,
        password: profileInput.password,
      },
      stopLoader,
      addToast,
      setUserData,
    )
    setEdit(!edit)
  }
  return (
    <Container className="container-fixed-header animated fadeIn">
      <Row className="mb-5">
        <Col md={12}>
          <Form>
            <ProfileSubContainer className="pt-4 pt-md-0 pt-lg-0">
              <ProfileTitle className="float-left">Profile Info</ProfileTitle>
              <EditProfile
                // TODO: Handle this case when change from edit to show
                to="/dashboard/profile/edit"
                className="float-right"
                onClick={() => {
                  setEdit(!edit)
                }}
              >
                <FontAwesomeIcon icon={faEdit} />
                &nbsp; Edit Profile
              </EditProfile>
              <ProfileSubContainer className="clearfix" />
            </ProfileSubContainer>
            <ProfileForm
              edit={edit}
              profileInput={profileInput}
              userData={userData}
              load={load}
              setInput={setProfileInput}
              // handleChange={handleChange}
              handleSubmit={handleSubmit}
            />
          </Form>
        </Col>
      </Row>
    </Container>
  )
}
